/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { combineReducers, Reducer } from 'redux';
import { IAction } from 'src/js/models/IshAction';
import { collegeReducer } from './College';
import { State } from '../../models/State';
import { loadingReducer } from './Loading';
import { portslWebsiteReducer } from 'src/js/redux/reducers/PortalWebsite';
import { sitesReducer } from './Sites';
import { googleReducer } from './Google';
import { formReducer } from './Form';
import { messageReducer } from './Message';
import { confirmReducer } from './Confirm';
import { settingsReducer } from './Settings';
import { systemPropertiesReducer } from './SystemProperties';
import { tagsReducer } from './Tags';

export const billingReducers: Reducer<State, IAction> = combineReducers(
  {
    college: collegeReducer,
    loading: loadingReducer,
    sites: sitesReducer,
    google: googleReducer,
    message: messageReducer,
    form: formReducer,
    confirm: confirmReducer,
    settings: settingsReducer,
    portalWebsite: portslWebsiteReducer,
    systemProperties: systemPropertiesReducer,
    tags: tagsReducer
  }
);
